import React, { useState, useEffect } from "react";
//Bootstrap
import PotentialIncomeTableRows from "./PotentialIncomeTableRows";
//Components
import TableHead from "../TableHead/TableHead";

export default function PotentialIncomeTable({
  potentialIncomes,
  setPotentialIncomes,
  potentialIncomeRows,
  setPotentialIncomeRows,
  tableHeads,
  deleteMonth,
}) {
  const [showPotentialIncomes, setShowPotentialIncomes] = useState(true);

  useEffect(() => {
    var month1 = 0;
    var month2 = 0;
    var month3 = 0;
    var month4 = 0;
    var month5 = 0;
    var month6 = 0;
    var month7 = 0;
    var month8 = 0;
    var month9 = 0;
    var month10 = 0;
    var month11 = 0;
    var month12 = 0;
    potentialIncomeRows.map((row) => {
      month1 += Number(row.potentialIncomeOne);
      month2 += Number(row.potentialIncomeTwo);
      month3 += Number(row.potentialIncomeThree);
      month4 += Number(row.potentialIncomeFour);
      month5 += Number(row.potentialIncomeFive);
      month6 += Number(row.potentialIncomeSix);
      month7 += Number(row.potentialIncomeSeven);
      month8 += Number(row.potentialIncomeEight);
      month9 += Number(row.potentialIncomeNine);
      month10 += Number(row.potentialIncomeTen);
      month11 += Number(row.potentialIncomeEleven);
      month12 += Number(row.potentialIncomeTwelve);
    });
    setPotentialIncomes({
      month1: month1,
      month2: month2,
      month3: month3,
      month4: month4,
      month5: month5,
      month6: month6,
      month7: month7,
      month8: month8,
      month9: month9,
      month10: month10,
      month11: month11,
      month12: month12,
    });
  }, [potentialIncomeRows]);

  const addRow = (id, details) => {
    const randomId = (Math.random() + 1).toString(36).substring(7);

    var newest;
    newest = potentialIncomeRows.slice(-1)[0];
    if (details) {
      //then create a blank new row
      if (id === "0x123") {
        if (potentialIncomeRows.length) {
        } else {
          const newEntry = {
            id: id,
          };
          setPotentialIncomeRows((prev) => {
            return [...prev, newEntry];
          });
        }
      }
    }

    if (!details) {
      //then create a blank new row
      if (id === newest.id) {
        const newEntry = {
          id: randomId,
          potentialIncomeOne: 0,
          potentialIncomeTwo: 0,
          potentialIncomeThree: 0,
          potentialIncomeFour: 0,
          potentialIncomeFive: 0,
          potentialIncomeSix: 0,
          potentialIncomeSeven: 0,
          potentialIncomeEight: 0,
          potentialIncomeNine: 0,
          potentialIncomeTen: 0,
          potentialIncomeEleven: 0,
          potentialIncomeTwelve: 0,
        };
        setPotentialIncomeRows((prev) => {
          return [...prev, newEntry];
        });
      }
    }
  };

  const removeRow = (id) => {
    if (potentialIncomeRows.length !== 1) {
      setPotentialIncomeRows((prev) => {
        return prev.filter((row) => {
          return row.id !== id;
        });
      });
    }
  };

  const setField = (field, id, value) => {
    let current = potentialIncomeRows.find((row) => row.id === id);

    if (current) {
      current[field] = value;

      setPotentialIncomeRows([...potentialIncomeRows]);
    } else {
      const row = {
        [field]: value,
        id: id,
      };
      setPotentialIncomeRows([...potentialIncomeRows, { row }]);
    }
  };

  const updateShow = () => {
    setShowPotentialIncomes(!showPotentialIncomes);
  };

  return (
    <div>
      <table className="incomeTable">
        <thead className="incomeTableheadborder">
          <TableHead
            header={"Potential Income"}
            tableHeads={tableHeads}
            deleteMonth={deleteMonth}
            updateShow={updateShow}
            show={showPotentialIncomes}
          />
        </thead>
        <tbody className="">
          {showPotentialIncomes &&
            potentialIncomeRows.map((row) => (
              <PotentialIncomeTableRows
                id={row.id}
                key={row.id}
                row={row}
                addRow={addRow}
                removeRow={removeRow}
                setField={setField}
                potentialIncomeRows={potentialIncomeRows}
              />
            ))}
        </tbody>
        <tfoot className="foot incomeFoot">
          <tr>
            <td></td>
            <td>{potentialIncomes.month1}</td>
            <td>{potentialIncomes.month2}</td>
            <td>{potentialIncomes.month3}</td>
            <td>{potentialIncomes.month4}</td>
            <td>{potentialIncomes.month5}</td>
            <td>{potentialIncomes.month6}</td>
            <td>{potentialIncomes.month7}</td>
            <td>{potentialIncomes.month8}</td>
            <td>{potentialIncomes.month9}</td>
            <td>{potentialIncomes.month10}</td>
            <td>{potentialIncomes.month11}</td>
            <td>{potentialIncomes.month12}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
